/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tooltip_governance_off_chain = () => `Off-chain governance is a form of blockchain governance where decisions are informally made off chain, (discussions typically happen in social media or forums). The result of discussions is based on the unanimous agreement among the community.`
